document.addEventListener("DOMContentLoaded", function () {

  // ✅ Run ONLY on desktop (no mobile / tablet)
  if (window.innerWidth <= 1024) return;

  const cursor = document.createElement("div");
  cursor.classList.add("minimal-cursor");
  document.body.appendChild(cursor);

  let mouseX = 0, mouseY = 0;
  let posX = 0, posY = 0;

  document.addEventListener("mousemove", (e) => {
    mouseX = e.clientX;
    mouseY = e.clientY;
  });

  function animate() {
    posX += (mouseX - posX) * 0.12;
    posY += (mouseY - posY) * 0.12;

    cursor.style.transform = `translate(${posX}px, ${posY}px) translate(-50%, -50%)`;

    requestAnimationFrame(animate);
  }

  animate();

  const hoverEls = document.querySelectorAll("a, button");

  hoverEls.forEach((el) => {
    el.addEventListener("mouseenter", () => {
      cursor.classList.add("hover");
    });

    el.addEventListener("mouseleave", () => {
      cursor.classList.remove("hover");
    });
  });

});